import type { AppState } from "@soheil/core";

export const uid = (): string =>
  Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

export const STATE_VERSION = 1;

export function seedState(): AppState {
  const now = Date.now();
  const habit = (
    title: string, neverZero: string, domain: string, icon: string,
    extra: Partial<import("@soheil/core").Habit> = {}, order = 0,
  ) => ({
    id: uid(), title, neverZero, domain, icon,
    scheduleType: "daily" as const, scheduleConfig: {},
    archived: false, sortOrder: order, createdAt: now, updatedAt: now,
    ...extra,
  });

  return {
    version: STATE_VERSION,
    settings: {
      displayName: "",
      character: "soheil_bear",
      waterGoal: 8,
      focusDurationMin: 25,
      breakDurationMin: 5,
      soundEnabled: false,
      reduceMotion: false,
    },
    habits: [
      habit("۳۰ دقیقه مطالعه", "یک صفحه بخوان", "مطالعه", "📖", {}, 0),
      habit("۲۰ دقیقه پیاده‌روی", "۲ دقیقه دمِ در قدم بزن", "ورزش", "🚶", {}, 1),
      habit("زود خوابیدن", "۱۵ دقیقه زودتر از دیشب", "سلامت", "🌙", {}, 2),
    ],
    habitLogs: [],
    tasks: [],
    mind: [],
    health: [],
    sessions: [],
    stars: [],
    progress: {
      totalStars: 0, level: 1, currentStreak: 0, longestStreak: 0,
      freezeTokens: 1, studyMinutes: 0,
    },
    reviews: [],
  };
}
